export default {
  data() {
    return {
      ruleCommissionConst: [
        {label: 'Prix total sans TDS', value: 'WITHOUT_TDS'},
        {label: 'Prix total sans TDS et sans frais de ménage', value: 'WITHOUT_TDS_HOUSEWORK'},
      ],
    };
  },
  methods: {},
};
